"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sharing = void 0;
require("reflect-metadata");
const typedi_1 = require("typedi");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const http_1 = require("@completeanatomy/http");
const store_1 = require("@completeanatomy/store");
const utils_1 = require("./utils/utils");
const GroupsAPI_1 = require("./api/GroupsAPI");
const MembershipsAPI_1 = require("./api/MembershipsAPI");
let Sharing = class Sharing {
    constructor(http, store) {
        this.http = http;
        this.store = store;
        this.reducerName = 'userGroups';
        this.groupsAPI = new GroupsAPI_1.GroupsAPI(this.http);
        this.membershipsAPI = new MembershipsAPI_1.MembershipsAPI(this.http);
        this.store.dispatch(this.createAction({ type: bridge_schema_1.bridgeObjectAdded, payload: [] }));
    }
    fetch() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.groupsAPI.getAll();
            this.overwriteAppState(result);
        });
    }
    create(group) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.groupsAPI.create(group);
            result.lastActivityTime = +Date.now();
            const userGroups = [...this.userGroupsInAppState, result];
            this.overwriteAppState(userGroups);
            return result;
        });
    }
    update(id, group) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.groupsAPI.update(id, group);
            result.lastActivityTime = +Date.now();
            const userGroups = this.userGroupsInAppState.map(groupInAppState => result.identifier === groupInAppState.identifier
                ? result
                : groupInAppState);
            this.overwriteAppState(userGroups);
        });
    }
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.groupsAPI.delete(id);
            const userGroups = this.userGroupsInAppState.filter(groupInAppState => id !== groupInAppState.identifier);
            this.overwriteAppState(userGroups);
        });
    }
    inviteByEmail(email, groupId) {
        return __awaiter(this, void 0, void 0, function* () {
            const member = yield this.membershipsAPI.inviteByEmail({
                email,
                user_group: groupId,
            });
            const userGroups = this.updateUserGroupMembers(groupId, member);
            this.overwriteAppState(userGroups);
        });
    }
    leaveGroup({ group, to_user_id, }) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.membershipsAPI.leaveGroup({
                to_user_id,
                group,
            });
            const userGroups = this.userGroupsInAppState.filter(groupInAppState => group !== groupInAppState.identifier);
            this.overwriteAppState(userGroups);
            // @ts-ignore
            (_c = (_b = (_a = window.Manager) === null || _a === void 0 ? void 0 : _a.GroupsManager) === null || _b === void 0 ? void 0 : _b.loadGroups) === null || _c === void 0 ? void 0 : _c.call(_b);
        });
    }
    acceptGroup(data) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.membershipsAPI.accept(data);
            yield this.fetch();
            // @ts-ignore
            yield ((_c = (_b = (_a = window.Manager) === null || _a === void 0 ? void 0 : _a.GroupsManager) === null || _b === void 0 ? void 0 : _b.loadGroups) === null || _c === void 0 ? void 0 : _c.call(_b));
            // @ts-ignore
            (_f = (_e = (_d = window.Manager) === null || _d === void 0 ? void 0 : _d.SyncManager) === null || _e === void 0 ? void 0 : _e.loadIDContentForSync) === null || _f === void 0 ? void 0 : _f.call(_e);
        });
    }
    removeUserFromGroup(membershipId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { groupId, member } = yield this.membershipsAPI.removeUserFromGroup(membershipId);
            const userGroups = this.updateUserGroupMembers(groupId, member, true);
            this.overwriteAppState(userGroups);
        });
    }
    inviteToGroup(groupId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const member = yield this.membershipsAPI.inviteUserToGroup({
                group: groupId,
                to_user_id: userId,
            });
            const userGroups = this.updateUserGroupMembers(groupId, member);
            this.overwriteAppState(userGroups);
        });
    }
    decline(membershipId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.membershipsAPI.decline({ membershipId });
        });
    }
    retractAdmin(membershipId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { groupId, member } = yield this.membershipsAPI.retractAdmin(membershipId);
            const userGroups = this.updateUserGroupMembers(groupId, member);
            this.overwriteAppState(userGroups);
        });
    }
    grantAdmin(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { groupId, member } = yield this.membershipsAPI.grantAdmin(data);
            const userGroups = this.updateUserGroupMembers(groupId, member);
            this.overwriteAppState(userGroups);
        });
    }
    getMembersByGroup(groupId, limit, offset) {
        return __awaiter(this, void 0, void 0, function* () {
            const members = yield this.membershipsAPI.getByGroup(groupId, limit, offset);
            const userGroups = this.userGroupsInAppState.map(group => {
                if (group.identifier === groupId) {
                    const allMembers = (0, utils_1.checkForDuplicates)(group.members, members);
                    const founderIndex = allMembers.findIndex(member => member.userIdentifier === group.founder);
                    if (founderIndex !== -1) {
                        const founder = allMembers[founderIndex];
                        founder.isFounder = true;
                        allMembers.splice(founderIndex, 1);
                        allMembers.unshift(founder);
                    }
                    return Object.assign(Object.assign({}, group), { members: allMembers });
                }
                return group;
            });
            this.overwriteAppState(userGroups);
        });
    }
    // TODO: to decide whether we will need the current call or not
    get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const result = yield this.groupsAPI.get(id);
            // this.overwriteAppState([result]);
        });
    }
    overwriteAppState(groups) {
        this.store.dispatch(this.createAction({ type: bridge_schema_1.bridgeObjectChanged, payload: groups }));
    }
    createAction({ type, payload, keyPath = '', }) {
        const actionType = `${this.reducerName}/${type}`;
        let actionPayload;
        switch (type) {
            case bridge_schema_1.bridgeObjectAdded:
                actionPayload = {
                    identifier: this.reducerName,
                    object: payload,
                };
                break;
            case bridge_schema_1.bridgeObjectChanged:
                actionPayload = {
                    identifier: this.reducerName,
                    changes: payload,
                    keyPath,
                };
                break;
            case bridge_schema_1.bridgeObjectRemoved:
                actionPayload = {
                    identifier: this.reducerName,
                };
                break;
        }
        return {
            type: actionType,
            payload: actionPayload,
        };
    }
    updateUserGroupMembers(groupId, member, remove) {
        return this.userGroupsInAppState.map(group => {
            var _a, _b;
            if (group.identifier !== groupId)
                return group;
            const members = group.members;
            member.isFounder = group.founder === member.userIdentifier;
            if (members) {
                const memberIndex = members.findIndex(({ identifier }) => identifier === member.identifier);
                if (memberIndex === -1) {
                    members.push(member);
                    group.membersCount = ((_a = group.membersCount) !== null && _a !== void 0 ? _a : 0) + 1;
                    return group;
                }
                else if (remove) {
                    members.splice(memberIndex, 1);
                    group.membersCount = ((_b = group.membersCount) !== null && _b !== void 0 ? _b : 1) - 1;
                    return group;
                }
                /**
                 * In case member is found but remove is false, we need to replace it with the new data
                 */
                members.splice(memberIndex, 1, member);
                return group;
            }
            return group;
        });
    }
    get userGroupsInAppState() {
        return this.store.getState() || [];
    }
    updateLastActivityTime(groupId) {
        const group = this.userGroupsInAppState.find(({ identifier }) => identifier === groupId);
        if (!group) {
            return;
        }
        group.lastActivityTime = +Date.now();
        const userGroups = this.userGroupsInAppState.map(groupInAppState => group.identifier === groupInAppState.identifier ? group : groupInAppState);
        this.overwriteAppState(userGroups);
    }
};
exports.Sharing = Sharing;
exports.Sharing = Sharing = __decorate([
    (0, typedi_1.Service)(),
    __param(1, (0, store_1.InjectStore)('userGroups')),
    __metadata("design:paramtypes", [http_1.HTTP,
        store_1.InjectedStore])
], Sharing);
